import { FronteggContext } from '@frontegg/rest-api';
import { AxiosAmbient } from 'src/lib';
import {
  templateStylePreferencesLoading,
  templateStylePreferencesSlice,
} from '../slices/memory';
import { showToastError } from 'src/utilities/errortoast';

export const listTemplateStylePreferences = () => {
  return async (dispatch) => {
    dispatch(templateStylePreferencesLoading(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const params = {};
    const result = await AxiosAmbient.get(`/template_style_preferences`, {
      headers,
      params,
    });
    const response = result?.data;
    if (result?.status === 200) {
      dispatch(templateStylePreferencesSlice(response));
    } else {
      showToastError('Failed to load templates');
    }

    dispatch(templateStylePreferencesLoading(false));
  };
};

export const updateTemplateStylePreferences = (
  template_style_preference_id,
  preferences,
  onSuccess = null
) => {
  return async (dispatch) => {
    dispatch(templateStylePreferencesLoading(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const data = {
      preferences: preferences,
    };
    const result = await AxiosAmbient.put(
      `/template_style_preferences/${template_style_preference_id}`,
      data,
      { headers }
    );
    if (result?.status === 200) {
      dispatch(listTemplateStylePreferences());
      if (onSuccess) {
        onSuccess();
      }
    } else {
      showToastError('Failed to update template style preferences');
    }
    dispatch(templateStylePreferencesLoading(false));
  };
};

export const deleteTemplateStylePreferences = (
  template_style_preference_id
) => {
  return async (dispatch) => {
    dispatch(templateStylePreferencesLoading(true));

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await AxiosAmbient.delete(
      `/template_style_preferences/${template_style_preference_id}`,
      { headers }
    );

    if (result?.status === 200) {
      dispatch(listTemplateStylePreferences());
    } else {
      showToastError('Failed to delete template style preferences');
    }
    dispatch(templateStylePreferencesLoading(false));
  };
};
